window.addEventListener('DOMContentLoaded', () => {
  const backToTopBtn = document.querySelector('.main-page__back-to-top button');

  backToTopBtn.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
});
